(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
async function $79970c066e9fdc37$export$2cdf1b96a9f86d16(text) {
    await navigator.clipboard.writeText(text);
}


//
// After a successful login we are redirected to the UI with our username
// and a JWT token. We need to save these in local storage so Verdaccio
// thinks we are logged in.
//
/**
 * Returns cookies as an object
 */ function $d5a52bfbb9163aeb$export$d2e637738f5e6ae8(cookieStr) {
    return cookieStr.split(";").filter((str)=>str.includes("=")).map((str)=>str.split("=")).reduce((result, [key, value])=>({
            ...result,
            [decodeURIComponent(key.trim())]: decodeURIComponent(value.trim())
        }), {});
}
function $d5a52bfbb9163aeb$export$83cd1f1503eb19c0(token) {
    // JWT has 3 parts separated by ".", the payload is the base64url-encoded part in the middle
    const base64Url = token.split(".")[1];
    // base64url replaced '+' and '/' with '-' and '_', so we undo it here
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("")// atob decoded the base64 string, but multi-byte characters (emojis for example)
    // are not decoded properly. For example, "🍀" looks like "ð\x9F\x8D\x80". The next
    // line converts bytes into URI-percent-encoded format, for example "%20" for space.
    // Lastly, the decodeURIComponent wrapping this can correctly get a UTF-8 string.
    .map((c)=>"%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)).join(""));
    return JSON.parse(jsonPayload);
}
function $d5a52bfbb9163aeb$export$9369b12211e1fce4(action) {
    for(let i = 0; i < 10; i++)setTimeout(()=>action(), 100 * i);
}
function $d5a52bfbb9163aeb$var$pathContainsElement(selector, e) {
    const path = e.path || e.composedPath?.();
    const element = document.querySelector(selector);
    return path.includes(element);
}
function $d5a52bfbb9163aeb$export$60561518b076cb2c(selector, callback) {
    const handleClick = (e)=>{
        if ($d5a52bfbb9163aeb$var$pathContainsElement(selector, e)) {
            e.preventDefault();
            e.stopPropagation();
            callback();
        }
    };
    const capture = true;
    document.addEventListener("click", handleClick, capture);
}


function $6f4879fde176caf7$export$787d85d17a1ab0c9(credentials) {
    localStorage.setItem("username", credentials.username);
    localStorage.setItem("token", credentials.uiToken);
    localStorage.setItem("npm", credentials.npmToken);
}
function $6f4879fde176caf7$export$d1b63878dfcc70a6() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("npm");
}
function $6f4879fde176caf7$export$256a5a3564694cfc() {
    return !!localStorage.getItem("username") && !!localStorage.getItem("token") && !!localStorage.getItem("npm");
}
function $6f4879fde176caf7$export$b007d77a962aa175() {
    const token = localStorage.getItem("token");
    if (typeof token !== "string") return true;
    const payload = (0, $d5a52bfbb9163aeb$export$83cd1f1503eb19c0)(token);
    if (!payload) return true;
    // Report as expired before (real expiry - 30s)
    const jsTimestamp = payload.exp * 1000 - 30000;
    return Date.now() >= jsTimestamp;
}
function $6f4879fde176caf7$export$65f22a49577e07ee(credentials) {
    return credentials.username && credentials.uiToken && credentials.npmToken;
}


var $9f8e58cd02f7b9f5$exports = {};
$9f8e58cd02f7b9f5$exports = JSON.parse("{\"$schema\":\"http://json.schemastore.org/package\",\"name\":\"verdaccio-github-oauth-ui\",\"version\":\"7.1.8\",\"keywords\":[\"authentication\",\"github\",\"login\",\"npm\",\"oauth\",\"package\",\"private\",\"registry\",\"verdaccio\",\"verdaccio-auth\",\"verdaccio-auth-plugin\",\"verdaccio-plugin\"],\"homepage\":\"https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md\",\"bugs\":\"https://github.com/n4bb12/verdaccio-github-oauth-ui/issues\",\"repository\":\"github:n4bb12/verdaccio-github-oauth-ui\",\"license\":\"MIT\",\"author\":\"Abraham Schilling\",\"main\":\"dist/server/index.js\",\"bin\":\"dist/cli/index.js\",\"files\":[\"dist\"],\"scripts\":{\"build\":\"bash run build\",\"clean\":\"bash run clean\",\"cli\":\"bash run cli\",\"cli:login\":\"bash run cli-login\",\"cli:publish\":\"bash run cli-publish\",\"cli:whoami\":\"bash run cli-whoami\",\"copy\":\"bash run copy\",\"coverage\":\"vitest --coverage\",\"dev\":\"run-s update start\",\"docker\":\"bash run docker_\",\"fix\":\"run-s format typecheck\",\"format\":\"prettier --write \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"format:check\":\"prettier --check \\\"**/*.{ts,js,css,scss,html,json}\\\"\",\"prepack\":\"bash run clean && bash run build\",\"start\":\"verdaccio -c verdaccio.yaml\",\"test\":\"vitest\",\"typecheck\":\"bash run typecheck\",\"update\":\"run-s prepack copy\",\"watch\":\"nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \\\"bun dev\\\"\"},\"dependencies\":{\"@npmcli/config\":\"^11.0.1\",\"@octokit/oauth-methods\":\"^6.0.4\",\"@octokit/request\":\"^10.0.15\",\"@verdaccio/core\":\"^8.3.0\",\"@verdaccio/url\":\"^13.1.3\",\"dotenv\":\"^17.4.2\",\"express\":\"^5.2.1\",\"lodash\":\"^4.18.1\",\"memory-cache\":\"^0.2.0\",\"minimist\":\"^1.2.8\",\"octokit\":\"^5.0.5\",\"open\":\"^11.0.1\",\"ow\":\"^3.1.1\",\"picocolors\":\"^1.1.1\",\"query-string\":\"^9.5.0\",\"undici\":\"^8.10.0\"},\"devDependencies\":{\"@parcel/config-default\":\"^2.16.4\",\"@types/express\":\"^5.0.6\",\"@types/lodash\":\"^4.17.25\",\"@types/memory-cache\":\"^0.2.6\",\"@types/minimist\":\"^1.2.5\",\"@types/node\":\"^26.4.0\",\"@types/npmcli__config\":\"^6.0.4\",\"@types/query-string\":\"^6.3.0\",\"@verdaccio/types\":\"^13.0.6\",\"@vitest/coverage-v8\":\"^4.1.11\",\"browserslist\":\"^4.28.8\",\"core-js\":\"^3.50.0\",\"nodemon\":\"^3.1.14\",\"npm-run-all2\":\"^9.0.3\",\"parcel\":\"^2.16.4\",\"prettier\":\"^3.9.6\",\"process\":\"^0.11.10\",\"release-it\":\"^21.0.2\",\"timekeeper\":\"^2.3.1\",\"type-fest\":\"^5.8.0\",\"typescript\":\"^7.0.2\",\"verdaccio\":\"^6.10.1\",\"verdaccio-htpasswd\":\"^13.1.3\",\"vite-tsconfig-paths\":\"^6.1.1\",\"vitest\":\"^4.1.11\"},\"peerDependencies\":{\"verdaccio\":\">=6\"},\"engines\":{\"node\":\">=20\"},\"publishConfig\":{\"registry\":\"https://registry.npmjs.org/\"},\"targets\":{\"client\":{\"source\":\"src/client/verdaccio-6.ts\",\"distDir\":\"dist/client\",\"context\":\"browser\",\"includeNodeModules\":true},\"server\":{\"source\":\"src/server/index.ts\",\"distDir\":\"dist/server\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false,\"isLibrary\":true},\"cli\":{\"source\":\"src/cli/index.ts\",\"distDir\":\"dist/cli\",\"context\":\"node\",\"outputFormat\":\"commonjs\",\"optimize\":false}}}");


const $53427f141080796d$export$3a689f099db7e338 = (0, (/*@__PURE__*/$parcel$interopDefault($9f8e58cd02f7b9f5$exports))).name;
const $53427f141080796d$export$18d4026d1ea86bb1 = (0, (/*@__PURE__*/$parcel$interopDefault($9f8e58cd02f7b9f5$exports))).name.replace("verdaccio-", "");
const $53427f141080796d$export$42fcb85fa5803dac = "/-/oauth/authorize";
const $53427f141080796d$export$9e960429933a7149 = "/-/oauth/callback";
const $53427f141080796d$export$cf98473208e53590 = $53427f141080796d$export$42fcb85fa5803dac;
const $53427f141080796d$export$bd46c9d2d39fc9 = "/";
const $53427f141080796d$export$3c6c1020e175037c = 8239;
const $53427f141080796d$export$32fbdff0ec95e1c6 = "cli";
const $53427f141080796d$export$b3d17af05dbcae2f = "/oauth/authorize";
const $53427f141080796d$export$a5232dc62cc3d68c = "https://github.com";
const $53427f141080796d$export$5b53df5f02ece893 = "https://api.github.com";
const $53427f141080796d$export$827c2d0b213c39b9 = [
    "$all",
    "@all",
    "$authenticated",
    "@authenticated"
];




function $bcf4aa743666fa03$var$saveAndRemoveCookies() {
    if ((0, $6f4879fde176caf7$export$b007d77a962aa175)()) (0, $6f4879fde176caf7$export$d1b63878dfcc70a6)();
    if ((0, $6f4879fde176caf7$export$256a5a3564694cfc)()) return;
    const credentials = (0, $d5a52bfbb9163aeb$export$d2e637738f5e6ae8)(document.cookie);
    if (!(0, $6f4879fde176caf7$export$65f22a49577e07ee)(credentials)) return;
    (0, $6f4879fde176caf7$export$787d85d17a1ab0c9)(credentials);
    Object.keys(credentials).forEach((key)=>document.cookie = `${key}=;expires=${new Date(0).toUTCString()}`);
    location.reload();
}
function $bcf4aa743666fa03$export$2cd8252107eb640b(options) {
    $bcf4aa743666fa03$var$saveAndRemoveCookies();
    const { loginButton: loginButton, logoutButton: logoutButton, updateUsageInfo: updateUsageInfo } = options;
    (0, $d5a52bfbb9163aeb$export$60561518b076cb2c)(loginButton, ()=>{
        location.href = (0, $53427f141080796d$export$cf98473208e53590);
    });
    (0, $d5a52bfbb9163aeb$export$60561518b076cb2c)(logoutButton, ()=>{
        (0, $6f4879fde176caf7$export$d1b63878dfcc70a6)();
        if (location.pathname === (0, $53427f141080796d$export$bd46c9d2d39fc9)) location.reload();
        else location.href = (0, $53427f141080796d$export$bd46c9d2d39fc9);
    });
    document.addEventListener("click", ()=>(0, $d5a52bfbb9163aeb$export$9369b12211e1fce4)(updateUsageInfo));
    (0, $d5a52bfbb9163aeb$export$9369b12211e1fce4)(updateUsageInfo);
}


//
// Replace the default npm usage info and displays the authToken that needs
// to be configured.
//
function $8c9a92aa69cf3f75$export$9dc0174526f4c7e3() {
    const username = localStorage.getItem("username");
    if (!username) return "Click the login button to authenticate with GitHub.";
    const configBase = window.VERDACCIO_API_URL ? window.VERDACCIO_API_URL.replace(/^https?:/, "").replace(/-\/verdaccio\/$/, "") : `//${location.host}${location.pathname}`;
    const authToken = localStorage.getItem("npm");
    return [
        `npm config set ${configBase}:_authToken "${authToken}"`
    ].join("\n");
}




const $79b6276ea3079348$var$loginButtonSelector = `[data-testid="header--button-login"]`;
const $79b6276ea3079348$var$logoutButtonSelector = `[data-testid="header--button-logout"],[data-testid="logOutDialogIcon"]`;
const $79b6276ea3079348$var$tabSelector = `[data-testid="tab-content"]`;
function $79b6276ea3079348$var$updateUsageInfo() {
    const loggedIn = (0, $6f4879fde176caf7$export$256a5a3564694cfc)();
    if (!loggedIn) return;
    const tabs = document.querySelectorAll($79b6276ea3079348$var$tabSelector);
    if (!tabs) return;
    const usageInfoLines = (0, $8c9a92aa69cf3f75$export$9dc0174526f4c7e3)().split("\n").reverse();
    tabs.forEach((tab)=>{
        const alreadyReplaced = tab.getAttribute("replaced") === "true";
        if (alreadyReplaced) return;
        const commands = Array.from(tab.querySelectorAll("button")).map((node)=>node.parentElement).filter((node)=>!!node.innerText.match(/^(npm|pnpm|yarn)/));
        if (!commands.length) return;
        usageInfoLines.forEach((info)=>{
            const cloned = commands[0].cloneNode(true);
            const textEl = cloned.querySelector("span");
            textEl.innerText = info;
            const copyEl = cloned.querySelector("button");
            copyEl.style.visibility = loggedIn ? "visible" : "hidden";
            copyEl.onclick = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                (0, $79970c066e9fdc37$export$2cdf1b96a9f86d16)(info);
            };
            commands[0].parentElement.appendChild(cloned);
            tab.setAttribute("replaced", "true");
        });
        // Remove commands that don't work with oauth
        commands.forEach((node)=>{
            if (node.innerText.includes("adduser") || node.innerText.includes("set password")) {
                node.parentElement.removeChild(node);
                tab.setAttribute("replaced", "true");
            }
        });
    });
}
(0, $bcf4aa743666fa03$export$2cd8252107eb640b)({
    loginButton: $79b6276ea3079348$var$loginButtonSelector,
    logoutButton: $79b6276ea3079348$var$logoutButtonSelector,
    updateUsageInfo: $79b6276ea3079348$var$updateUsageInfo
});

})();
//# sourceMappingURL=verdaccio-6.js.map
